import { style } from 'typestyle';
import { TEAL_PRIMARY, faintBorderColor, mediumBorderColor, mediumBreakpoint } from 'src/utils/Style/Theme';
import { rangePx } from 'src/utils/Style/Media';

const itemHeight = 60;

export const modal = style({
  display: 'flex !important',
  justifyContent: 'flex-start',
  overflow: 'hidden !important',
  $nest: {
    '.s5-MuiDialog-container ': {
      margin: '0 auto',
      width: 'auto',
    },
    '.configure-header-row': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginBottom: '1rem',
      $nest: {
        '.instructions': {
          fontSize: '0.9rem',
          margin: 0,
        },
        '.configure-search': {
          marginLeft: 'auto',
        },
      },
    },
    '.configure-search': {
      width: 220,
      flexShrink: 0,
      fontSize: '0.9rem',
      $nest: {
        '& .s5-MuiOutlinedInput-input': {
          padding: '0.5rem',
          fontFamily: '"Open Sans", sans-serif',
          fontSize: '0.9rem',
        },
        '& i': {
          color: mediumBorderColor,
        },
        '&:hover fieldset': {
          borderColor: '#29ffee',
        },
        '&.Mui-focused .s5-MuiOutlinedInput-notchedOutline': {
          color: '#495057',
          borderColor: '#29ffee',
          outline: 0,
          boxShadow: '0 0 0 0.2rem rgba(0, 168, 155, 0.25)',
        },
      },
    },
    '.s5-MuiDialogTitle-root': {
      color: 'white',
      backgroundColor: TEAL_PRIMARY,
      width: '100%',
      padding: '1rem',
      $nest: {
        '.s5-MuiTypography-h6': {
          display: 'flex',
          $nest: {
            '.right-container': {
              flex: 1,
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'center',
              fontSize: '1.8rem',
              cursor: 'pointer',
            },
            '.icon': {
              marginRight: '0.5rem',
              fontSize: '1.5rem',
            },
          },
        },
      },
    },
    '.s5-MuiDialogContent-root': {
      display: 'grid',
      padding: '2rem 4rem',
      $nest: {
        '> main': {
          display: 'flex',
          [rangePx(0, mediumBreakpoint)]: {
            width: 600,
          },
        },
        '.option-group': {
          width: 300,
          height: 500,
          display: 'flex',
          position: 'relative',
          flexDirection: 'column',
          [rangePx(0, mediumBreakpoint)]: {
            width: '50%',
          },
          $nest: {
            '& + .option-group': {
              marginLeft: '1rem',
            },
            '> header': {
              fontSize: '1.2rem',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              height: '10%',
            },
            '> ul': {
              flex: 1,
              margin: 0,
              padding: 0,
              overflowY: 'auto',
              paddingRight: 5,
            },
            '&.selectable .option:not(.disabled)': {
              cursor: 'pointer',
            },
            '&:not(.selectable) .overlay': {
              position: 'absolute',
              width: '100%',
              height: '100%',
              backgroundColor: 'white',
              opacity: 0.7,
              zIndex: 1,
            },
          },
        },
        '.clear-choice': {
          position: 'absolute',
          right: '10px',
          fontSize: '1.1rem',
          top: '10px',
        },
        '.option': {
          height: itemHeight,
          marginBottom: '1rem',
          backgroundColor: faintBorderColor,
          fontWeight: 300,
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'relative',
          $nest: {
            '&.selected': {
              color: 'white',
              backgroundColor: TEAL_PRIMARY,
              fontWeight: 'normal',
            },
            '&.disabled': {
              color: '#ddd',
            },
          },
        },
        '> footer': {
          display: 'grid',
          gridTemplateColumns: 'repeat(2, 1fr)',
          gridGap: '0.4rem',
          justifySelf: 'end',
          paddingTop: '1rem',
        },
      },
    },
  },
});
